function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.194 4.008a9.23 9.23 0 011.23 2.018c2.023 4.545.021 9.919-4.448 11.908a8.792 8.792 0 01-4.897.657L8.554 20l-1.337-1.903-.081-.03.021-.056-.924-1.315 3.872-.856-.503 1.353a7.33 7.33 0 003.782-.588c3.73-1.66 5.41-6.17 3.71-9.987a7.772 7.772 0 00-.833-1.436l-.203-.264 1.136-.91zM12.037 0l1.97 2.804-3.285.727.4-1.076a7.341 7.341 0 00-4.293.513c-3.73 1.66-5.41 6.17-3.71 9.987.225.507.505.989.833 1.436l.203.264-1.136.91a9.23 9.23 0 01-1.23-2.018C-.233 9.002 1.769 3.63 6.238 1.64a8.8 8.8 0 015.4-.566l.4-1.073z",
  fill: "#FFF",
  fillRule: "nonzero"
});

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSearch;